import { PROMO_TYPE } from 'src/common/promo';
import { signal } from '@preact/signals';

interface PromoStoreProps {
    type: PROMO_TYPE | undefined;
    phaseCounter: boolean | undefined;
    phaseEvent: boolean | undefined;
    phaseGame: boolean | undefined;
    phaseHistory: boolean | undefined;
    countdownStart: number | undefined;
    countdownEnd: number | undefined;
    eventStart: number | undefined;
}

export default function createPromoStore(props: PromoStoreProps) {
    const { type, phaseCounter, phaseEvent, phaseGame, phaseHistory, countdownEnd, countdownStart, eventStart }: PromoStoreProps = props;

    return {
        type: signal(type),
        phaseCounter: signal(phaseCounter),
        phaseEvent: signal(phaseEvent),
        phaseGame: signal(phaseGame),
        phaseHistory: signal(phaseHistory),
        countdownStart: signal(countdownStart),
        countdownEnd: signal(countdownEnd),
        eventStart: signal(eventStart),
    };
}
